__turbopack_context__.v({
  "address": "footer-module-scss-module__BKh3Zq__address",
  "appRating": "footer-module-scss-module__BKh3Zq__appRating",
  "borderTop": "footer-module-scss-module__BKh3Zq__borderTop",
  "brand": "footer-module-scss-module__BKh3Zq__brand",
  "container": "footer-module-scss-module__BKh3Zq__container",
  "footer": "footer-module-scss-module__BKh3Zq__footer",
  "logo": "footer-module-scss-module__BKh3Zq__logo",
  "navigation": "footer-module-scss-module__BKh3Zq__navigation",
  "socialIcons": "footer-module-scss-module__BKh3Zq__socialIcons",
});
